import checkout from "./form";

const {
  formField: { taxId, conpanyName, director, creator, method, date, sendTo, chiefAccountant, address, unit },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [address.name]: "",
  [conpanyName.name]: "",
  [director.name]: "",
  [creator.name]: "",
  [sendTo.name]: "",
  [chiefAccountant.name]: "",
  [unit.name]: "",
};

export default initialValues;
